module.exports = __webpack_public_path__ + "static/beige-0d63a02d77d38c6e246d53141c84c685.png";